import React from 'react';
import BaseLayout from '@components/layouts/BaseLayout';
import CrawlQueueTable from '@components/features/CrawlQueue/CrawlQueueTable';
import { Typography } from '@mui/material';

const EventPageHandlerPage = () => {
  return (
    <BaseLayout>
      <Typography variant="h4" component="h1" gutterBottom>
        Crawl Queue
      </Typography>
      <CrawlQueueTable />
    </BaseLayout>
  );
};

export default EventPageHandlerPage;
